
define('ui-helper/accessibility-helper',['jquery', 'knockout'], function($) {

    var AccessibilityHelper = {

        fixUserMenuDropdown: function() {
            var $userMenuButton = $('#userMenuButton');
            var $userMenu = $('#header-user-menu');
            var $userNameLi = $('.user-name.position-relative');

            if (!$userMenuButton.length || !$userMenu.length) return;

            $userMenuButton.removeAttr('data-bs-toggle');
            $userMenuButton.off('click.bs.dropdown keydown.bs.dropdown');
            $(document).off('keydown.bs.dropdown.data-api');
            $(document).off('click.userMenuDropdown');

            var isOpen = false;

            function isEnterOrSpace(e) {
                var keyCode = e.keyCode || e.which;
                return keyCode === 13 || keyCode === 32; // Enter veya Space
            }

            function isArrowDown(e) {
                return (e.keyCode || e.which) === 40;
            }

            function isArrowUp(e) {
                return (e.keyCode || e.which) === 38;
            }

            function toggleMenu() {
                isOpen = !isOpen;
                $userMenuButton
                    .toggleClass('opened', isOpen)
                    .attr('aria-expanded', isOpen ? 'true' : 'false');

                $userMenu
                    .toggle(isOpen)
                    .attr('aria-hidden', isOpen ? 'false' : 'true');

                $userMenu.find('a[role="menuitem"]')
                    .attr('tabindex', isOpen ? '0' : '-1');
            }

            $userMenuButton.on('click.userMenuDropdown', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                toggleMenu();
            });

            $userMenuButton.on('keydown.userMenuDropdown', function(e) {
                if (isEnterOrSpace(e) || isArrowDown(e)) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!isOpen) toggleMenu();
                }
            });

            $userMenu.on('keydown.userMenuDropdown', 'a[role="menuitem"]', function(e) {
                if (!isArrowDown(e) && !isArrowUp(e)) return;

                e.preventDefault();
                var $items = $userMenu.find('a[role="menuitem"]:visible');
                var currentIndex = $items.index(this);
                var itemCount = $items.length;
                var nextIndex;

                if (isArrowDown(e)) {
                    nextIndex = (currentIndex + 1) % itemCount;
                } else {
                    nextIndex = (currentIndex - 1 + itemCount) % itemCount;
                }

                $items.eq(nextIndex).focus();
            });

            $(document).on('click.userMenuDropdown', function(e) {
                if (isOpen && !$(e.target).closest($userNameLi).length) {
                    toggleMenu();
                }
            });

            $userMenu.hide().attr('aria-hidden', 'true');
            $userMenuButton.attr('aria-expanded', 'false');
        },

        fixModalSelectboxes: function(modalId) {
            setTimeout(function() {
                var $selects = $(modalId + ' select.dropdownselect, ' + modalId + ' select[data-bind*="dropdownselect"]');

                $selects.each(function() {
                    var $select = $(this);
                    var labelId = $select.attr('aria-labelledby');

                    if (!labelId) return;

                    var $wrapper = $select.parent().find('.btn-group.bootstrap-select').first();

                    if ($wrapper.length === 0) {
                        $wrapper = $select.nextAll('.btn-group.bootstrap-select').first();
                    }

                    if ($wrapper.length === 0) {
                        $wrapper = $select.closest('.tk-input-field, .input-field, .form-group, .col-md-3, .mb-10').find('.btn-group.bootstrap-select').first();
                    }

                    if ($wrapper.length === 0) return;

                    var $button = $wrapper.find('button');

                    if ($button.length > 0) {
                        $button.attr({
                            'aria-labelledby': labelId,
                            'role': 'combobox',
                            'aria-haspopup': 'listbox'
                        });

                        if ($select.prop('disabled') || $select.attr('disabled') !== undefined) {
                            $button.attr('aria-disabled', 'true');
                        } else {
                            $button.removeAttr('aria-disabled');
                        }
                    }
                });
            }, 1000);
        }



    };

    return AccessibilityHelper;
});